export const initFlash = () => {
  const flashes = document.querySelectorAll('.flash-message')
  flashes.forEach(flash => {
    setTimeout(() => {
      flash.style.transition = 'opacity 0.5s ease-out'
      flash.style.opacity = '0'
      setTimeout(() => {
        flash.remove()
      }, 500)
    }, 2000)
  })
}
